module.exports = __webpack_public_path__ + "img/pointVolunteer.b8c5c5a7.png";